import { render, staticRenderFns } from "./CellcardFrame.vue?vue&type=template&id=3dd1b6a3&scoped=true"
import script from "./CellcardFrame.vue?vue&type=script&lang=js"
export * from "./CellcardFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd1b6a3",
  null
  
)

export default component.exports